import { Injectable } from '@angular/core';

interface CountryMeta {
  flag: string;     
  gmtOffset: number;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class CountryInfoService {
  private readonly map: Record<string, CountryMeta> = {
    BRL: { flag: 'assets/flags/4x3/br.svg', gmtOffset: -3, name: 'Brasil' },
    MXN: { flag: 'assets/flags/4x3/mx.svg', gmtOffset: -6, name: 'Mexico' },
    CLP: { flag: 'assets/flags/4x3/cl.svg', gmtOffset: -4, name: 'Chile' },
    PEN: { flag: 'assets/flags/4x3/pe.svg', gmtOffset: -5, name: 'Peru' },
    COP: { flag: 'assets/flags/4x3/co.svg', gmtOffset: -5, name: 'Colombia' },
  };

  getMeta(currencyCode: string): CountryMeta | undefined {
    return this.map[currencyCode];
  }
}
